import { BodyTextBoldPrimary } from '@/shared/ui/typography';
import Spinner from '@/shared/assets/animated-spinner.svg';

import { styled } from 'styled-components';

export const StyledSum = styled(BodyTextBoldPrimary)`
  ${({ $status }) =>
    $status === 'pending' &&
    ` 
    color: #55648A;
   
    `}
  ${({ $status }) =>
    $status === 'success' &&
    ` 
    color: #08AD5E;
   
    `}
      ${({ $status }) =>
    $status === 'error' &&
    ` 
    color: #DA4444;
   
    `}

      ${({ $status }) =>
    $status === 'denied' &&
    ` 
    color: #DA4444;
   
    `}


     ${({ $status }) =>
    $status === 'verification' &&
    ` 
    color: #55648A;
   
    `}
`;

export const StatusIcon = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  right: 0;
  bottom: -4px;

  ${({ $status }) =>
    $status === 'error' &&
    `
     background-color: #DA4444;
    background-image: url('/images/icons/close-remove.svg');
    background-repeat: no-repeat;
    background-size: 12px;
    background-position: center;
    `}

  ${({ $status }) =>
    $status === 'denied' &&
    `
    background-color: #DA4444;
    background-image: url('/images/icons/close-remove.svg');
    background-repeat: no-repeat;
    background-size: 12px;
    background-position: center;
    `}

    ${({ $status }) =>
    $status === 'verification' &&
    `
     background-color: #55648A;

    `}

    ${({ $status }) =>
    $status === 'pending' &&
    `
     background-color: #55648A;

    `}
`;

export const AnimatedSpinner = styled(Spinner)`
  animation: rotate 2s linear infinite;
  z-index: 12;
  width: 16px;
  height: 16px;
  padding: 1px;

  circle {
    stroke: #fff;
    stroke-width: 2;
    position: relative;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
`;

export const TransactionType = styled(BodyTextBoldPrimary)`
  text-transform: capitalize;
`;

export const AddressIcon = styled.div`
  width: 14px;
  height: 14px;
  background-image: ${(props) => `url(${props.$iconUrl})`};
  background-repeat: no-repeat;
  background-size: 14px;
  background-position: cover;
`;
